export default __webpack_public_path__ + "duplicate.asset.237551cd3606e4768e3f6ffc57fb4bb9.svg";